import { SpeechTokenError } from "shared/errors";

export class SpeechService {
  httpClient;
  baseUrl;

  constructor(baseUrl, apiClient) {
    this.httpClient = apiClient;
    this.baseUrl = baseUrl;
  }

  fetchToken = async () => {
    const url = `${this.baseUrl}/speech/get-speech-token`;
    const response = await this.httpClient.get(url);
    // isSuccessful is only returned as false when an error has occurred
    if (response.isSuccessful === false) {
      throw new SpeechTokenError();
    }
    return response.data;
  };
}
